import classNames from "classnames";
import React from "react";
import ReactAvatar, { ReactAvatarProps } from "react-avatar";

const Avatar: React.FC<ReactAvatarProps> = ({
  src,
  size = "80px",
  name = "",
  className,
  ...props
}) => {
  return (
    <ReactAvatar
      {...(props as any)}
      colors={["#325BED"]}
      name={name}
      src={src}
      size={size}
      round
      fgColor="#fff"
      className={classNames("bg-[#325BED]", className)}
      textSizeRatio={1.75}
    />
  );
};

export default Avatar;
